import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import TopBar from "./TopBar";
import { useI18n } from "../i18n/I18nContext";

export default function Header() {
    const { t } = useI18n();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const links = [
        { to: "/", label: t("nav.home"), end: true, testid: "nav-home" },
        { to: "/services", label: t("nav.services"), testid: "nav-services" },
        { to: "/biens", label: t("nav.properties"), testid: "nav-properties" },
        { to: "/reservation", label: t("booking.nav"), testid: "nav-booking" },
        { to: "/demande", label: t("nav.request"), testid: "nav-request" },
        { to: "/couture", label: t("nav.couture"), testid: "nav-couture" },
        { to: "/a-propos", label: t("nav.about"), testid: "nav-about" },
        { to: "/contact", label: t("nav.contact"), testid: "nav-contact" },
    ];

    return (
        <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-xl border-b border-gray-100" data-testid="site-header">
            <TopBar />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-6">
                <Link to="/" data-testid="header-logo-link">
                    <Logo />
                </Link>
                <nav className="hidden lg:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `relative text-[0.78rem] tracking-[0.18em] uppercase font-semibold transition-colors ${
                                    isActive
                                        ? "text-brand-emerald"
                                        : "text-brand-navy hover:text-brand-emerald"
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    {l.label}
                                    <span
                                        className={`absolute -bottom-2 left-0 right-0 h-[2px] bg-brand-emerald transition-transform origin-left ${isActive ? "scale-x-100" : "scale-x-0"}`}
                                    />
                                </>
                            )}
                        </NavLink>
                    ))}
                </nav>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => navigate("/demande")}
                        className="hidden sm:inline-flex items-center px-6 py-3 bg-brand-gold hover:bg-brand-gold-deep text-white text-[0.72rem] tracking-[0.22em] uppercase font-semibold transition-colors"
                        data-testid="header-quote-btn"
                    >
                        {t("nav.quote")}
                    </button>
                    <button
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden p-2 text-brand-navy"
                        data-testid="mobile-menu-toggle"
                        aria-label="Menu"
                    >
                        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="lg:hidden border-t border-gray-100 bg-white" data-testid="mobile-menu">
                    <div className="px-4 py-4 flex flex-col gap-3">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.end}
                                onClick={() => setOpen(false)}
                                className="text-[0.78rem] tracking-[0.18em] uppercase font-semibold text-brand-navy py-2"
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
